export const TRANSFER_EVENT = "sfc:transfer:v1";
// Binary polling frames grow by 4/3. Leave ample room under the 1 MB limit.
export const CHUNK_BYTES = 256 * 1024;
export const MAX_MESSAGE_BYTES = 16 * 1024 * 1024;
export const TRANSFER_TTL_MS = 60_000;
export type TransferReply =
  | { ok: true; args?: unknown[] }
  | { ok: false; error: string };
export type TransportCallback = (
  error: Error | null,
  ...args: unknown[]
) => void;
